<template>
  <div id="pageContent">
    <div class="find-page">
      <div class="top">
        <img src="@/assets/img/dragons_text.png" alt="">
        <p class="title">비밀번호 찾기</p>
        <p class="sub">{{subText}}</p>
      </div>

      <!-- 1. 아이디 입력 -->
      <div v-if="order === 1" class="input-div">
        <input type="text" class="input-style" v-model="loginId" placeholder="아이디를 입력하세요">
        <button class="login-btn" @click="pwdFind">비밀번호 찾기</button>
      </div>
      <!-- 2. 본인인증 -->
      <div v-if="order === 2" class="user-citation">
        <Citation @authComplete="authComplete" :type="certType"/>
      </div>
      <!-- 3. 비밀번호 재입력 -->
      <div v-if="order === 3" class="input-div">
        <div class="pw-div bottom">
          <input :type="!pwdType ? 'password' : 'text'" id="password" v-model="pwdData.pw"
                 class="input-style"  placeholder="새로운 비밀번호 입력">
          <div class="eyes" @click="pwdType = !pwdType">
            <img :class="{off: !inputType}" :src="imageSrc(!pwdType ? 'off' : 'on')" alt="">
          </div>
        </div>
        <div class="pw-div">
          <input :type="!rePwdType ? 'password' : 'text'" id="repassword" v-model="pwdData.repw"
                 class="input-style"  placeholder="비밀번호 재입력">
          <div class="eyes" @click="rePwdType = !rePwdType">
            <img :class="{off: !inputType}" :src="imageSrc(!rePwdType ? 'off' : 'on')" alt="">
          </div>
        </div>
        <button class="login-btn" @click="pwdChange">비밀번호 변경</button>
      </div>
    </div>
  </div>
</template>

<script>
import {isEmpty} from '@/lib';
import Citation from '@/components/Common/Citation.vue';

export default {
  name: 'FindPassword',
  components: {Citation},
  data() {
    return {
      certType: 'findPassword',
      subText: '비밀번호 찾기를 하실 아이디를 입력하세요.',
      order: 1,
      loginId: '',
      userIdx: '',
      pwdData: {},
      pwdType: false,
      rePwdType: false,
      ci: '',
      certInfo: {}
    }
  },
  mounted () {
  },
  watch: {
    order: {
      handler: function () {
        switch (this.order) {
          case 2 :
            this.subText = '비밀번호 찾기를 위해서 본인인증이 필요합니다';
            break;
          case 3:
            this.subText = '새로 사용하실 비밀번호를 입력하세요';
            break;
          default :
            break;
        }
      }
    }
  },
  methods: {
    pwdFind() {
      if(isEmpty(this.loginId)) {
        alert('아이디를 입력하세요.');
        return false;
      }
      this.order = 2;
    },
    async authComplete(certType, certInfo) {
      const obj = {
        ci: certInfo.ci,
        user_id: this.loginId,
        realcheck_idx: certInfo.realcheck_idx
      }
      this.certInfo = certInfo;
      const {data} = await this.$http.post('/account/check_id_ci', obj);

      if (data.success) {
        this.userIdx = data.idx;
        this.order = 3;
      } else {
        alert(data.message);
        this.order = 1;
      }
    },
    async pwdChange() {
      if(isEmpty(this.pwdData.pw)) {
        alert('새로운 비밀번호를 입력하세요.');
        return false;
      }
      if(isEmpty(this.pwdData.repw)) {
        alert('새로운 비밀번호를 재입력하세요.');
        return false;
      }
      if(this.pwdData.pw !== this.pwdData.repw) {
        alert('비빌번호가 일치하지 않습니다.');
        return false;
      }

      const obj = {
        idx: this.userIdx,
        user_pw: this.pwdData.pw,
        re_password: this.pwdData.repw,
        ci: this.certInfo.ci,
        di: this.certInfo.di,
        realcheck_idx: this.certInfo.realcheck_idx
      }
      const {data} = await this.$http.post('/account/update_password', obj);
      if(data.success) {
        alert('비밀번호가 변경되었습니다.');
        this.$router.push({name: 'login'});
      } else {
        alert(data.message);
      }

    },
    imageSrc(imgSrc) {
      return require('@/assets/img/visibility_'+imgSrc+'.png');
    }
  }
}
</script>
